import { Heading, Spacer, Switch, Text } from '@sparemin/blockhead';
import React from 'react';
import AutomationPostModalBackButton from 'components/AutomationPostModalBackButton';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import useSocialPostShareStatus from 'containers/SocialShareModal/SocialSharePlatforms/useSocialPostShareStatus';
import DisclosureSection from 'containers/TikTokPostModal/steps/DisclosureSection';
import { socialShareModalBlock as block } from '../../../../utils';

export type TikTokDisclosureStepProps = {
  isDisclosureVisible: boolean;
  brandContent: boolean;
  brandOrganic: boolean;
  showDisabledText: boolean;
  onBrandContentChange: (brandContent: boolean) => void;
  onBrandOrganicChange: (brandOrganic: boolean) => void;
  onVisibilityChange: (isDisclosureVisible: boolean) => void;
  onBackClick: () => void;
  resetComposerValues: () => void;
};

const TikTokDisclosureStep: React.FC<TikTokDisclosureStepProps> = ({
  isDisclosureVisible,
  brandContent,
  brandOrganic,
  showDisabledText,
  onBrandContentChange,
  onBrandOrganicChange,
  onVisibilityChange,
  onBackClick,
  resetComposerValues,
}) => {
  useSocialPostShareStatus({ onSuccess: resetComposerValues });

  return (
    <SocialShareModalBody showHeader={false}>
      <Spacer
        orientation="vertical"
        space="14px"
        align="center"
        justify="center"
        className={block('step-contents-container')}
      >
        <AutomationPostModalBackButton
          text="Disclose video content"
          onClick={onBackClick}
        />

        <Spacer
          orientation="horizontal"
          space="20px"
          align="center"
          justify="space-between"
        >
          <Heading level={4} className={block('tiktok-disclosure-description')}>
            Turn on to disclose that your videos promote goods or services in
            exchange for something of value. Your videos could promote yourself,
            a third party, or both.
          </Heading>

          <Switch
            isSelected={isDisclosureVisible}
            onChange={onVisibilityChange}
          />
        </Spacer>

        {isDisclosureVisible && (
          <DisclosureSection
            {...{
              brandContent,
              brandOrganic,
              onBrandContentChange,
              onBrandOrganicChange,
            }}
          />
        )}

        {showDisabledText && (
          <Text variant="legal">
            * You need to indicate if your content promotes yourself, a third
            party, or both.
          </Text>
        )}
      </Spacer>
    </SocialShareModalBody>
  );
};

export default TikTokDisclosureStep;
